<template>
    <div>
        <div class="header">
            <span class="head" @click="yearMin"> <i class="el-icon-d-arrow-left"></i> </span
            ><span class="head" @click="monthMin"> <i class="el-icon-arrow-left"></i> </span
            ><span class="year">{{ year }} 年 {{ month }} 月</span
            ><span class="head" @click="monthPlus">
                <i class="el-icon-arrow-right"></i>
            </span>

            <span class="head" @click="yearPlus">
                <i class="el-icon-d-arrow-right"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        year: Number,
        month: Number,
    },
    data() {
        return {};
    },
    methods: {
        yearMin(){
            if (this.year>1970) {
                this.$emit('yearNum',this.year-1)
            }
        },
        yearPlus(){
            this.$emit('yearNum',this.year+1)
        },
        monthMin(){
            if (this.month==1) {
                this.$emit('yearNum',this.year-1)
                this.$emit('monthNum',12)
            }else{
                this.$emit('monthNum',this.month-1)
            }
        },
        monthPlus(){
            if (this.month == 12) {
                this.$emit('yearNum',this.year+1)
                this.$emit('monthNum',1)
            }else{
                this.$emit('monthNum',this.month+1)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.header {
    height: 26px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    span {
        flex: 0.5;
        text-align: center;
        height: 100%;
    }
    .year {
        flex: 3;
    }
    .head {
        cursor: pointer;
        &:hover {
            color: #409eff;
        }
    }
}
</style>